import forEach from 'lodash/forEach'

export default class SwitchController {
  constructor($scope, $attrs, $element, elementService) {
    'ngInject'
    this._$scope = $scope
    this._$attrs = $attrs
    this._$element = $element
    this._elementService = elementService
  }

  $onInit() {
    // Re-define $render
    this.ngModelCtrl.$render = () =>
      this.ngModelCtrl.$setViewValue(this.ngModelCtrl.$viewValue)

    // Set a watch to run render if any changes to the model occur outside of the component
    this._$scope.$watch(
      () => this.ngModelCtrl.$viewValue,
      () => {
        this.ngModelCtrl.$render()
      },
      true
    )
  }

  $postLink() {
    const classes = this._elementService.getClasses(this._$element)
    const modifiers = this._elementService.getComponentAttrs(
      this._$attrs,
      'modifier'
    )

    classes.push('vd-switch')

    if (modifiers) {
      forEach(modifiers, modifier => classes.push(`vd-switch--${modifier}`))
    }

    this._$attrs.$set('class', classes.join(' '))
  }
}
